import React, { useState } from 'react';
import Api from '@app/api/Api.js';
import './styles.scss';

export default function LoginForm() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      await Api.post('api/login', { username, password });
      window.location.href = Drupal.url('');
    } catch (err) {
      const msg = err?.response?.data?.message ?? Drupal.tt('Credenziali non valide.');
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form className="login-form user-login-form" onSubmit={handleSubmit} noValidate>
      <div className="form-item">
        <input
          type="text"
          placeholder={Drupal.tt('Username')}
          value={username}
          onChange={e => setUsername(e.target.value)}
          disabled={submitting}
          autoComplete="username"
        />
      </div>

      <div className="form-item">
        <input
          type="password"
          placeholder={Drupal.tt('Password')}
          value={password}
          onChange={e => setPassword(e.target.value)}
          disabled={submitting}
          autoComplete="current-password"
        />
      </div>

      {error && (
        <ul className="login-errors">
          <li>{error}</li>
        </ul>
      )}

      <div className="form-actions">
        <button type="submit" disabled={submitting}>
          {submitting ? '...' : Drupal.tt('sign in')}
        </button>
        <a href={Drupal.url('user/password')} className="forgot-password-link">
          {Drupal.tt('Password dimenticata?')}
        </a>
      </div>
    </form>
  );
}
